import { Map, List } from 'immutable';

import { practicePracticeEfectorVisitsActions } from './actions';
import { PracticeEfectorVisits } from './practice-efectores-visits';
import { DEFAULT_SESSION_ID } from '../constants';

export const initialState = new Map({
  currentPracticePracticeEfectorVisitsId: DEFAULT_SESSION_ID,
  [DEFAULT_SESSION_ID]: new PracticeEfectorVisits({id: DEFAULT_SESSION_ID, isNew: false})
});

export function practicesEfectoresVisitsReducer(state = initialState, action) {
  const { payload, type } = action

  switch (type) {
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_FAILED:
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_SUCCESS:
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_PENDING:
      return state.set(
        payload.practicePracticeEfectorVisitsId,
        practicesEfectorVisitsReducer(state.get(payload.practicePracticeEfectorVisitsId), action)
      );
    case practicePracticeEfectorVisitsActions.LOAD_PRACTICE_EFECTOR_VISITS:
      return state.merge({
        currentPracticePracticeEfectorVisitsId: payload.practicePracticeEfectorVisitsId,
        [payload.practicePracticeEfectorVisitsId]: practicesEfectorVisitsReducer(state.get(payload.practicePracticeEfectorVisitsId), action)
      });
    default:
      return state;
  }
}

export const practicesEfectorVisitsReducer = (state = new PracticeEfectorVisits() , { payload, type }  ) => {

  switch (type) {
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_SUCCESS:
      return state.withMutations(practiceEfectors => {
          practiceEfectors.merge({
            isNew: false,
            isPending: false,
            items: new List(payload.data),
            updated_at: new Date(),
          });
      });
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_FAILED:
      return state.set('isPending', false);
    case practicePracticeEfectorVisitsActions.FETCH_PRACTICE_EFECTOR_VISITS_PENDING:
      return state.set('isPending', true);
    case practicePracticeEfectorVisitsActions.LOAD_PRACTICE_EFECTOR_VISITS:
      return state.merge({
            id: payload.practicePracticeEfectorVisitsId,
            filters: payload.filters,
        });
    default:
      return state;
  }
}
